/*
  FILMS — la salle
  Pour Adrien d'Elzius · page Films v2

  L'écran et le programme : survoler un film le met à l'écran (à la
  souris), cliquer le lance. Au doigt, toucher un film le met à l'écran
  et y remonte. L'extrait ne tourne que sur ordinateur, quand l'écran est
  visible, jamais en mode économie de données ni quand le visiteur a
  demandé moins d'animations. Le son ne part jamais sans un clic.

  La salle : le film entier, avec le son, par-dessus la page. À la fin,
  le film suivant se lance après un court décompte, qu'on peut arrêter.
*/
(function () {
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  var souris = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var reseau = navigator.connection || {};
  var econome = reseau.saveData === true || /(^|-)2g$/.test(reseau.effectiveType || '');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function jouer(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function init(root) {
    if (root.__fil) return;
    root.__fil = 1;

    var ecrans = $$('[data-fil-screen]', root);
    var lignes = $$('[data-fil-row]', root);
    var carnets = $$('[data-fil-carnet]', root);
    var annonce = root.querySelector('[data-fil-live]');
    var boite = root.querySelector('[data-fil-screens]');
    if (!ecrans.length) return;

    var cur = Math.max(0, ecrans.findIndex(function (s) { return s.classList.contains('is-on'); }));
    var visible = false;
    var muet = true;
    var salleOuverte = false;
    var dernierPointeur = '';

    /* ────────── l'extrait ────────── */
    function apercu() {
      ecrans.forEach(function (s, i) {
        var v = s.querySelector('[data-fil-preview]');
        if (!v) return;
        var actif = i === cur && visible && !salleOuverte && souris.matches && !calme.matches && !econome;
        if (actif) {
          if (!v.getAttribute('src')) {
            v.setAttribute('src', v.getAttribute('data-src'));
            v.addEventListener('playing', function () { v.classList.add('is-play'); }, { once: true });
          }
          v.muted = muet;
          jouer(v);
        } else {
          v.pause();
        }
      });
    }

    if ('IntersectionObserver' in window && boite) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        apercu();
      }, { threshold: 0.35 }).observe(boite);
    }
    souris.addEventListener && souris.addEventListener('change', apercu);

    $$('[data-fil-mute]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        muet = !muet;
        $$('[data-fil-mute]', root).forEach(function (x) {
          x.setAttribute('aria-pressed', muet ? 'false' : 'true');
          var t = x.querySelector('[data-fil-mute-t]');
          if (t) t.textContent = muet ? (root.getAttribute('data-muted') || t.textContent) : (root.getAttribute('data-unmuted') || t.textContent);
        });
        var v = ecrans[cur].querySelector('[data-fil-preview]');
        if (v) v.muted = muet;
      });
    });

    /* ────────── changer de film ────────── */
    function choisir(i) {
      if (i === cur || !ecrans[i]) return;
      cur = i;
      ecrans.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-on', on);
        if (on) { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); }
        else { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
      });
      lignes.forEach(function (l, k) {
        l.classList.toggle('is-on', k === i);
        l.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      carnets.forEach(function (c, k) { c.hidden = k !== i; });
      if (annonce) annonce.textContent = ecrans[i].getAttribute('data-title') || '';
      apercu();
    }

    var attente = 0;
    lignes.forEach(function (l, i) {
      l.addEventListener('pointerdown', function (e) { dernierPointeur = e.pointerType; });
      l.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !souris.matches) return;
        clearTimeout(attente);
        attente = setTimeout(function () { choisir(i); }, 120);
      });
      l.addEventListener('pointerleave', function () { clearTimeout(attente); });
      l.addEventListener('click', function (e) {
        clearTimeout(attente);
        var clavier = e.detail === 0;
        var aLaSouris = !clavier && dernierPointeur === 'mouse' && souris.matches;
        choisir(i);
        if (aLaSouris) {
          if (ecrans[i].getAttribute('data-full')) ouvrir(i);
          else {
            var a = ecrans[i].querySelector('.fil__acts a');
            if (a) a.click();
          }
          return;
        }
        if (clavier) {
          var cible = ecrans[i].querySelector('.fil__acts button, .fil__acts a');
          if (cible) setTimeout(function () { cible.focus({ preventScroll: false }); }, 30);
          return;
        }
        /* Au doigt : on remonte jusqu'à l'écran. Le thème fait défiler la page
           dans son propre conteneur, pas dans la fenêtre : scrollIntoView
           trouve le bon, et scroll-margin-top garde l'écran sous l'en-tête. */
        if (boite && boite.getBoundingClientRect().top < 0) {
          boite.scrollIntoView({ block: 'start', behavior: calme.matches ? 'auto' : 'smooth' });
        }
      });
    });

    /* ────────── la salle ────────── */
    var salle = root.querySelector('[data-fil-salle]');
    if (!salle || typeof salle.showModal !== 'function') {
      // Sans <dialog> : « Regarder » ouvre le fichier du film.
      $$('[data-fil-watch]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var s = b.closest('[data-fil-screen]');
          if (s && s.getAttribute('data-full')) window.location.href = s.getAttribute('data-full');
        });
      });
      return;
    }
    if (salle.parentNode !== document.body) document.body.appendChild(salle);

    var video = salle.querySelector('[data-fil-salle-video]');
    var titre = salle.querySelector('[data-fil-salle-title]');
    var prec = salle.querySelector('[data-fil-prev]');
    var suiv = salle.querySelector('[data-fil-next]');
    var precT = salle.querySelector('[data-fil-prev-t]');
    var suivT = salle.querySelector('[data-fil-next-t]');
    var fin = salle.querySelector('[data-fil-end]');
    var finK = salle.querySelector('[data-fil-end-k]');
    var finNom = salle.querySelector('[data-fil-end-name]');
    var finGo = salle.querySelector('[data-fil-end-go]');
    var finReste = salle.querySelector('[data-fil-end-stay]');
    var motSuivant = root.getAttribute('data-next') || '';
    var enSalle = -1;
    var decompte = 0;
    var retour = null;
    var verrou = false;

    var jouables = [];
    ecrans.forEach(function (s, i) { if (s.getAttribute('data-full')) jouables.push(i); });

    function voisin(i, d) {
      if (jouables.length < 2) return -1;
      var k = jouables.indexOf(i);
      return jouables[(k + d + jouables.length) % jouables.length];
    }
    function nom(i) { return ecrans[i] ? (ecrans[i].getAttribute('data-title') || '') : ''; }

    function arreterDecompte() { clearInterval(decompte); decompte = 0; }
    function cacherFin() { arreterDecompte(); fin.hidden = true; }

    function charger(i) {
      var s = ecrans[i];
      if (!s || !s.getAttribute('data-full')) return;
      enSalle = i;
      cacherFin();
      titre.textContent = nom(i) + (s.getAttribute('data-meta') ? ' · ' + s.getAttribute('data-meta') : '');
      video.poster = s.getAttribute('data-poster') || '';
      video.src = s.getAttribute('data-full');
      video.muted = false;
      jouer(video);
      var p = voisin(i, -1), n = voisin(i, 1);
      prec.hidden = p < 0 || p === n; suiv.hidden = n < 0;
      if (p >= 0) precT.textContent = nom(p);
      if (n >= 0) suivT.textContent = nom(n);
      choisir(i);
    }

    function ouvrir(i) {
      if (!salle || !ecrans[i] || !ecrans[i].getAttribute('data-full')) return;
      retour = document.activeElement;
      var x = document.querySelector('[data-acc-player].is-open [data-acc-player-close]');
      if (x) x.click();
      salleOuverte = true;
      apercu();
      // Le thème bloque le défilement de sa page avec cet attribut.
      if (!document.documentElement.hasAttribute('scroll-lock')) {
        document.documentElement.setAttribute('scroll-lock', '');
        verrou = true;
      }
      salle.showModal();
      charger(i);
      video.focus({ preventScroll: true });
    }

    /* Le rangement ne dépend pas du seul événement « close » : certains
       navigateurs le retardent. Il est appelé à chaque sortie, une fois. */
    function ranger() {
      if (!salleOuverte) return;
      salleOuverte = false;
      cacherFin();
      video.pause();
      video.removeAttribute('src');
      video.load();
      if (verrou) { document.documentElement.removeAttribute('scroll-lock'); verrou = false; }
      apercu();
      if (retour && retour.focus) retour.focus({ preventScroll: true });
    }
    function fermer() { if (salle.open) salle.close(); ranger(); }
    salle.addEventListener('close', ranger);
    salle.addEventListener('cancel', function () { setTimeout(ranger, 0); });

    $$('[data-fil-watch]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.closest('[data-fil-screen]');
        ouvrir(ecrans.indexOf(s));
      });
    });
    salle.querySelector('[data-fil-close]').addEventListener('click', fermer);
    prec.addEventListener('click', function () { var p = voisin(enSalle, -1); if (p >= 0) charger(p); });
    suiv.addEventListener('click', function () { var n = voisin(enSalle, 1); if (n >= 0) charger(n); });
    salle.addEventListener('keydown', function (e) {
      if (e.target === video) return;
      if (e.key === 'ArrowLeft') { var p = voisin(enSalle, -1); if (p >= 0) { e.preventDefault(); charger(p); } }
      if (e.key === 'ArrowRight') { var n = voisin(enSalle, 1); if (n >= 0) { e.preventDefault(); charger(n); } }
    });
    // Un clic sur le fond (hors de la vidéo et des boutons) ferme la salle.
    salle.addEventListener('click', function (e) { if (e.target === salle) fermer(); });

    video.addEventListener('ended', function () {
      var n = voisin(enSalle, 1);
      fin.hidden = false;
      if (n < 0) {
        finK.textContent = '';
        finNom.textContent = '';
        finGo.hidden = true;
        finReste.focus();
        return;
      }
      finGo.hidden = false;
      finNom.textContent = nom(n);
      if (calme.matches) {
        finK.textContent = motSuivant;
        finGo.focus();
        return;
      }
      var reste = 5;
      finK.textContent = motSuivant + ' ' + reste + ' s';
      decompte = setInterval(function () {
        reste -= 1;
        if (reste <= 0) { arreterDecompte(); charger(n); return; }
        finK.textContent = motSuivant + ' ' + reste + ' s';
      }, 1000);
      finGo.focus();
    });
    video.addEventListener('play', cacherFin);
    finGo.addEventListener('click', function () { var n = voisin(enSalle, 1); if (n >= 0) charger(n); });
    finReste.addEventListener('click', function () { arreterDecompte(); finK.textContent = ''; finGo.hidden = true; });
  }

  function demarrer(scope) { $$('[data-fil]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
